module.exports = __webpack_public_path__ + "static/media/breakApart.096efaa7.svg";